export default __webpack_public_path__ + "static/media/icon_6_0.fef75997.svg";